/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiCostCenter, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of CostCentersController.
 */
export class CostCentersRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /cost_centers:prefill
     */
    public createPrefilled(): Promise<Result<ApiCostCenter>> {
        return this.http.post<Result<ApiCostCenter>, undefined>('/cost_centers:prefill', undefined);
    }

    /**
     * Calls GET /cost_centers:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiCostCenter>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiCostCenter>>>('/cost_centers:query', query);
    }

    /**
     * Calls POST /cost_centers:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiCostCenter>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiCostCenter>>, ListRequest>('/cost_centers:query', listRequest, query);
    }

    /**
     * Calls POST /cost_centers/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiCostCenter>>> {
        return this.http.post<Result<LockedContextDto<ApiCostCenter>>, undefined>(`/cost_centers/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /cost_centers/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiCostCenter>> {
        return this.http.post<Result<ApiCostCenter>, undefined>(`/cost_centers/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /cost_centers/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiCostCenter[]>> {
        return this.http.post<Result<ApiCostCenter[]>, string[]>('/cost_centers/locks', ids);
    }

    /**
     * Calls POST /cost_centers/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/cost_centers/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /cost_centers/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/cost_centers/${primaryId}/locks`);
    }

    /**
     * Calls GET /cost_centers/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiCostCenter>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiCostCenter>>(`/cost_centers/${primaryId}`, query);
    }

    /**
     * Calls POST /cost_centers
     */
    public add(dto: ApiCostCenter): Promise<Result<ApiCostCenter>> {
        return this.http.post<Result<ApiCostCenter>, ApiCostCenter>('/cost_centers', dto);
    }

    /**
     * Calls PUT /cost_centers/{primaryId}
     */
    public update(dto: ApiCostCenter, primaryId: string): Promise<Result<ApiCostCenter>> {
        return this.http.put<Result<ApiCostCenter>, ApiCostCenter>(`/cost_centers/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /cost_centers
     */
    public putRange(dtos: ApiCostCenter[]): Promise<Result<ApiCostCenter[]>> {
        return this.http.patch<Result<ApiCostCenter[]>, ApiCostCenter[]>('/cost_centers', dtos);
    }

    /**
     * Calls DELETE /cost_centers/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/cost_centers/${primaryId}`);
    }

    /**
     * Calls POST /costcenters:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiCostCenter>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiCostCenter>>, ListRequestWithIds>('/costcenters:batch', listRequest, query);
    }
}
